import { useState } from 'react';

import { ConfirmStopTrackModal } from './ConfirmStopTrackModal';
import { IdleModal } from './IdleModal';

export interface IdleModalContainerProps {
  open: boolean;
  msRemaining: number;

  onClose?(): void;
  onExit?(): void;
}

export const IdleModalContainer = ({ open, msRemaining, onClose, onExit }: IdleModalContainerProps) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <>
      <IdleModal open={open} msRemaining={msRemaining} onClose={onClose} onExit={() => setConfirmOpen(true)} />
      <ConfirmStopTrackModal open={confirmOpen} onClose={() => setConfirmOpen(false)} onConfirm={onExit} />
    </>
  );
};
